import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Grid, Header, Form, Segment, Button } from 'semantic-ui-react'

class SignInForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired
  }

  state = {
    formData: {
      email: '',
      password: ''
    }
  }

  onFieldChange = (field, value) => {
    let updatedFormData = {...this.state.formData}
    updatedFormData[field] = value
    this.setState({ formData: updatedFormData })
  }

  onKeyDown = (event) => {
    const { onSubmit } = this.props

    if (event.key === 'Enter') {
      onSubmit(this.state.formData)
    }
  }

  onSubmit = (e) => {
    e.preventDefault()
    this.props.onSubmit(this.state.formData);
  }

  onEmail = (event) => {
    this.onFieldChange('email', event.target.value)
  }

  onPassword = (event) => {
    this.onFieldChange('password', event.target.value)
  }

  render() {
    return (
      <div style={{marginTop: "100px"}}>
        <Grid textAlign='center' style={{ height: '100%' }} verticalAlign='middle'>
          <Grid.Column style={{ maxWidth: 450 }}>
            <Header as='h2' textAlign='center'>
              Admin Sign In
            </Header>
            <Form size='large'>
              <Segment>
                <Form.Input fluid icon='user' iconPosition='left' placeholder='Email' onChange={this.onEmail}/>
                <Form.Input
                  fluid
                  icon='lock'
                  iconPosition='left'
                  placeholder='Password'
                  type='password'
                  onChange={this.onPassword}
                />

                <Button onClick={e => this.onSubmit(e)} color='teal' fluid size='large'>
                  Login
                </Button>
              </Segment>
            </Form>
          </Grid.Column>
        </Grid>
      </div>
    )
  }
} // class SignInForm

export default SignInForm;
